import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PATH_TITLE_KEYS: Record<string, string> = {
  '/app/profile': 'docTitle.profile',
  '/app/profile/edit': 'docTitle.profileEdit',
  '/app/services': 'docTitle.services',
  '/app/services/scriber': 'docTitle.scriber',
  '/app/projects': 'docTitle.projects',
  '/app/projects/new': 'docTitle.projectNew',
  '/app/projects/:id': 'docTitle.projectDetail',
  '/app/organizations': 'docTitle.organizations',
  '/app/organizations/:id': 'docTitle.organizationDetail',
  '/app/services/:id': 'docTitle.serviceDetail',
  '/app/activity': 'docTitle.activity',
  '/app/activity/history': 'docTitle.activityHistory',
  '/app/archive': 'docTitle.archive',
  '/app/billing': 'docTitle.billing',
  '/app/billing/plans': 'docTitle.billingPlans',
  '/app/billing/payments': 'docTitle.billingPayments',
  '/app/billing/methods': 'docTitle.billingMethods',
  '/app/settings/interface': 'docTitle.settingsInterface',
  '/app/settings/security': 'docTitle.settingsSecurity',
  '/app/settings/notifications': 'docTitle.settingsNotifications',
  '/app/settings/privacy': 'docTitle.settingsPrivacy',
  '/app/settings/api-keys': 'docTitle.settingsApiKeys',
  '/app/referral': 'docTitle.referral',
  '/app/admin/roles': 'docTitle.adminRoles',
  '/app/admin/users': 'admin.usersTitle',
  '/app/admin/services': 'admin.servicesTitle',
};

export function useDocumentTitle() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const cleanPath = pathname.replace(/\/[0-9a-f-]{36,}/g, '/:id');
    let titleKey = PATH_TITLE_KEYS[cleanPath] ?? PATH_TITLE_KEYS[pathname];
    if (!titleKey && pathname.startsWith('/app/services/scriber')) {
      titleKey = 'docTitle.scriber';
    }
    document.title = titleKey
      ? `${t(titleKey)} | ${t('meta.baseTitle')}`
      : t('meta.baseTitle');
  }, [pathname, i18n.language, t]);
}
